const NO_LONGER_IN_ADDRESS_BOOK = "Firm no longer in the address book";

function namelessEntry(count: number, alone: boolean): string {
  if (count === 1 && alone) return NO_LONGER_IN_ADDRESS_BOOK;
  return `${count} ${count === 1 ? "firm" : "firms"} no longer in the address book`;
}

/**
 * The firm names to list, at most `limit`, and how many firms are left over. A firm with no name
 * is one the address book no longer has (merged away); those are grouped into one entry after the
 * named ones.
 */
export function firmNameEntries(
  names: Array<string | null>,
  limit: number,
): { shown: string[]; more: number } {
  const named = names.filter((name): name is string => !!name);
  const nameless = names.length - named.length;
  const shownNamed = named.slice(0, limit);
  const showsNameless = nameless > 0 && shownNamed.length < limit;
  const shown = showsNameless
    ? [...shownNamed, namelessEntry(nameless, shownNamed.length === 0)]
    : shownNamed;
  return { shown, more: names.length - shownNamed.length - (showsNameless ? nameless : 0) };
}
